import React, { useEffect } from 'react'
import AgentChatPanel from './AgentChatPanel'
import { POPPED_OUT_KEY } from './useAgentChatSync'

const AgentChatPopoutPage: React.FC = () => {
  useEffect(() => {
    document.title = 'GROBx AI'

    const onBeforeUnload = () => {
      localStorage.setItem(POPPED_OUT_KEY, 'false')
    }

    window.addEventListener('beforeunload', onBeforeUnload)
    return () => window.removeEventListener('beforeunload', onBeforeUnload)
  }, [])

  return <AgentChatPanel mode="standalone" />
}

export default AgentChatPopoutPage
